var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.361,
    height: 88.361,
    viewBox: "0 0 88.361 88.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1327",
    "data-name": "Group 1327",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(23.144 39.2) rotate(-79.1)",
    fill: "#93cc89"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236",
    "data-name": "Ellipse 236",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(51.756 34.625) rotate(-45)",
    fill: "#93cc89"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4131",
    "data-name": "Path 4131",
    d: "M1422.931,533.19a44.18,44.18,0,1,0,44.18,44.18A44.231,44.231,0,0,0,1422.931,533.19Zm39.225,44.18a39.225,39.225,0,1,1-39.225-39.225A39.27,39.27,0,0,1,1462.156,577.37Z",
    transform: "translate(-1378.75 -533.19)",
    fill: "#93cc89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4132",
    "data-name": "Path 4132",
    d: "M1546.336,876.96a2.482,2.482,0,0,0-3.269,1.258,24.814,24.814,0,0,1-45.352,0,2.477,2.477,0,0,0-4.526,2.014,29.77,29.77,0,0,0,54.408,0,2.477,2.477,0,0,0-1.259-3.27Z",
    transform: "translate(-1476.21 -826.322)",
    fill: "#93cc89"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreat);
export default __webpack_public_path__ + "static/media/Great.7b359e53ed1d3e71cbed37da662c6827.svg";
export { ForwardRef as ReactComponent };